export default __webpack_public_path__ + "assets/logo-blockchain-646e3362024a2b90e4f8884205e04da8.svg";